import { React, useState, useEffect, useContext } from "react";
import * as CONST from "../../../component/config/Constant";
import axios from "axios";
import { toast } from "react-toastify";
import { AuthContext } from "../../../component/context/AuthContext";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { FiCode, FiArrowRight } from "react-icons/fi";
import "../../../assets/css/home.css";

function Technologies() {
  const [authUserData] = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [activePage] = useState(1);
  const [perPage] = useState(50);
  const [dataSort] = useState({ order: "desc", order_by: "id" });
  const [searchParam] = useState({ srchStatus: "", srchTechnology: "" });

  let isToken = "";
  if (authUserData && authUserData[0]) {
    isToken = authUserData[0].token || "";
  }

  useEffect(() => {
    fetchTechnologyData();
  }, []);

  async function fetchTechnologyData() {
    setLoading(true);
    await axios.post(CONST.GET_TECH_LIST, {
      limit: perPage,
      search_input: searchParam,
      page_number: activePage,
      sort: dataSort,
    }).then((response) => {
      if (response.data.status === "success") {
        setData(response.data.data);
      }
    }).catch(() => {});
    setLoading(false);
  }

  return (
    <>
      <Helmet><title>Technologies | HRD Portal - eLuminous Technologies</title></Helmet>

      <section className="tech-hero">
        <div className="container">
          <div className="tech-hero-row">
            <div className="tech-hero-icon"><FiCode /></div>
            <div>
              <h1 className="tech-hero-title">Technologies</h1>
              <p className="tech-hero-sub">Explore our tech stack and knowledge base</p>
            </div>
          </div>
        </div>
      </section>

      <section className="tech-list-section">
        <div className="container">
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary spinner-border-sm" role="status" />
            </div>
          ) : data.length === 0 ? (
            <div className="text-center py-5 text-muted">No technologies found</div>
          ) : (
            <div className="row">
              {data.map((tech, index) => (
                <div className="col-lg-3 col-md-4 col-sm-6 mb-4" key={index}>
                  <Link to={`/tech-details/${tech.id}/${tech.name}`} className="tech-card-link">
                    <div className="tech-card">
                      <div className="tech-card-image">
                        <img src={CONST.HOST + tech.image_path} alt={tech.name} />
                      </div>
                      <div className="tech-card-body">
                        <h6 className="tech-card-name">{tech.name}</h6>
                        <span className="tech-card-view">
                          View Details <FiArrowRight size={14} />
                        </span>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}

export default Technologies;
